export const emailValidator = (value) =>
  /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)
    ? null
    : "Invalid email";

export const requiredValidator = (value) =>
  value && value.trim() !== "" ? null : "Required";
